import React from 'react';
import { Link } from 'react-router-dom';
import "./styles.css";
import '../../global.css';
import Header from '../../components/Header';
import {LucroMes, GastoMes, ReceitaMes} from '../../components/caixamensal';
import Footer from '../../components/Footer';

function UserHome() {
    return (
        <> 
            <Header />

            <h1 className = 'titulofluxo'>Caixa</h1>

            <div className = 'conteudo'>

                <section className = 'usuario' >
                    Bem vindo, UFFTech
                </section>

                <div className = 'usermenu' >

                    <li><Link to="/Relatórios">Relatórios</Link></li>
                    <li><Link to="/Pagamentos">Pagamentos</Link></li>
                    <li><Link to="/Recebimentos">Recebimentos</Link></li>
                    <li><Link to="/Dividas">Dívidas</Link></li>
                    <li><Link to="/Vendas">Vendas</Link></li>
                    <li><Link to="/Estoque">Estoque</Link></li>

                </div>
                
                <div className = 'principal'>

                    <div className = 'infoinicial'>
                        <h2>Receita</h2>
                        <p>R$ 500</p>
                    </div>

                    <div className = 'infoinicial'>
                        <h2>Gastos</h2>
                        <p>R$ 500</p>
                    </div>

                    <div className = 'infoinicial'>
                        <h2>Lucro</h2>
                        <p>R$ 500</p>
                    </div>

                </div>

                <div className = 'secao'>
                    <p>Lucro Semanal</p>
                    <section className = 'grafico'> <LucroMes/> </section>
                    <p className ="rodape"> Ver Mais</p>
                </div>

                <div className = 'secao'>
                    <p>Gastos Semanais</p>
                    <section className = 'grafico' > <GastoMes/> </section>
                    <p className ="rodape"> Ver Mais</p>
                </div>

                <div className = 'secao'>
                    <p>Receita</p>
                    <section className = 'grafico'> <ReceitaMes/> </section>
                    <p className ="rodape"> Ver Mais</p>
                </div>

                <div className = 'secao'>
                    <p>Recebimentos</p>
                    <section className = 'grafico' > Aqui terá um Gráfico da Variação do Caixa</section>
                    <p className ="rodape"> Ver Mais</p>
                </div>

            </div>

            <Footer/>
        </>
    );
}

export default UserHome;